<style src="./ListItems.scss" lang="scss"></style>
<template>
  <tbody class="tbody" cellspacing="10">
    <tr
      v-for="(item, itemIdx) in list"
      :key="itemIdx"
      class="list-items"
      :class="{ 'notquoted': !item.quoted.isQuoted }">
      <td scope="row" class="item id">
        <span class="lot">{{ item.itemInfo && item.itemInfo.lot || '' }}</span>
        <span
          class="number"
          :class="{ 'number__notassociated': !item.associated.isAssociated }">
          {{ item.itemInfo && item.itemInfo.number }}
        </span>
      </td>

      <td class="item strict">
        <span
          v-if="item.itemInfo && item.itemInfo.strictToME"
          class="strict-to-me"
          title="Restrito para Micro Empresa">
          ME
        </span>
      </td>
      <td class="item guaranted" title="Item com garantia de preço">
        <icon-star v-if="item.quoted && item.quoted.isPriceGuaranted" />
      </td>

      <td class="item description" :title="item.itemInfo && item.itemInfo.description">
        <span class="info description">{{ item.itemInfo && item.itemInfo.description }}</span>
      </td>

      <td class="item quantity field">
        <div class="colfield" :title="item.itemInfo.unity">
          <span class="value">{{ item.itemInfo && item.itemInfo.unity }}</span>
        </div>
      </td>

      <td
        class="item quantity field"
        :title="`A quantidade desse item é: ${item.itemInfo.quantity} ${item.itemInfo.unity} com fator de ${item.itemInfo.factor}`">
        <div class="colfield right" >
          <span class="value">{{ item.itemInfo && item.itemInfo.quantity | DecimalNumber }}</span>
        </div>
        <div class="colfield right">
          <span class="value">x{{ item.itemInfo && item.itemInfo.factor | DecimalNumber}}</span>
        </div>
      </td>

      <td v-if="!item.associated.isAssociated" colspan="3" class="cell__notassociated">NÃO ASSOCIADO</td>
      <td v-if="!item.associated.isAssociated" colspan="4" class="cell__notassociated">NÃO ASSOCIADO</td>
      <td v-if="!item.associated.isAssociated" colspan="3" class="cell__notassociated">NÃO ASSOCIADO</td>
      <td v-if="!item.associated.isAssociated" colspan="3" class="cell__notassociated">NÃO ASSOCIADO</td>
      <td v-if="!item.associated.isAssociated" colspan="3" class="cell__notassociated">NÃO ASSOCIADO</td>

      <template v-if="item.associated.isAssociated">
        <td
          :title="item.cost.lab"
          class="colfield lab">
          <span class="value">{{ item.cost.lab }}</span>
        </td>
        <td
          :title="item.cost.price | CurrencyBR"
          class="colfield unit">
          <span class="value">{{ item.cost.price | CurrencyBR }}</span>
        </td>
        <td
          :title="item.cost.total | CurrencyBR"
          class="colfield total separator">
          <span class="value">{{ item.cost.total | CurrencyBR }}</span>
        </td>
      </template>

      <template v-if="item.associated.isAssociated">
        <td
          :title="item.cmedQuoted.lab"
          class="colfield lab">
          <span class="value">{{ item.cmedQuoted.lab }}</span>
        </td>
        <td
          :title="item.cmedQuoted.computedValue | CurrencyBR"
          class="colfield unit">
          <span class="value">{{ item.cmedQuoted.computedValue | CurrencyBR }}</span>
        </td>
        <td
          :title="item.cmedQuoted.total | CurrencyBR"
          class="colfield total">
          <span class="value">{{ item.cmedQuoted.total | CurrencyBR }}</span>
        </td>
        <td class="colfield perc separator">
          <span class="value">{{ item.cmedQuoted.perc }}</span>
        </td>
      </template>

      <template v-if="item.associated.isAssociated">
        <td
          :title="item.itemInfo.estimatedPrice | CurrencyBR"
          class="colfield unit">
          <span class="value">{{ item.itemInfo.estimatedPrice | CurrencyBR }}</span>
        </td>
        <td
          :title="item.itemInfo.estimatedTotal | CurrencyBR"
          class="colfield total">
          <span class="value">{{ item.itemInfo.estimatedTotal | CurrencyBR }}</span>
        </td>
        <td class="colfield perc separator">
          <span class="value">{{ item.itemInfo.estimatedPerc }}</span>
        </td>
      </template>

      <template v-if="item.associated.isAssociated">
        <td
          :title="item.quoted.proposalPrice | CurrencyBR"
          class="colfield unit">
          <span class="value">{{ item.quoted.proposalPrice | CurrencyBR }}</span>
        </td>
        <td
          :title="item.quoted.proposalTotal | CurrencyBR"
          class="colfield total">
          <span class="value">{{ item.quoted.proposalTotal | CurrencyBR }}</span>
        </td>
        <td class="colfield perc separator">
          <span class="value">{{ item.quoted.proposalPerc }}</span>
        </td>
      </template>

      <template v-if="item.associated.isAssociated">
        <td
          :title="item.quoted.minimumPrice | CurrencyBR"
          class="colfield unit">
          <span class="value">{{ item.quoted.minimumPrice | CurrencyBR }}</span>
        </td>
        <td
          :title="item.quoted.minimumTotal | CurrencyBR"
          class="colfield total">
          <span class="value">{{ item.quoted.minimumTotal | CurrencyBR }}</span>
        </td>
        <td class="colfield perc separator">
          <span class="value">{{ item.quoted.minimumPerc }}</span>
        </td>
      </template>
      
      <td class="ranking distributor">
        <div
          v-for="(ranking, rankingIdx, idx) in item.result"
          :key="rankingIdx"
          class="value distributor">
          <span class="position">{{ idx + 1 }}</span>
          <span>{{ ranking.distributor }}</span>
        </div>
      </td>
      <td class="ranking lab">
        <span
          v-for="(ranking, rankingIdx) in item.result"
          :key="rankingIdx"
          class="value lab">{{ ranking.lab }}</span>
      </td>
      <td class="ranking unit">
        <span
          v-for="(ranking, rankingIdx) in item.result"
          :key="rankingIdx"
          class="value unit">{{ ranking.offer | CurrencyBR }}</span>
      </td>
      <td class="ranking total">
        <span
          v-for="(ranking, rankingIdx) in item.result"
          :key="rankingIdx"
          class="value total">{{ ranking.total | CurrencyBR }}</span>
      </td>
      <td class="ranking perc separator">
        <span
          v-for="(ranking, rankingIdx) in item.result"
          :key="rankingIdx"
          class="value perc">{{ ranking.perc }}</span>
      </td>
    </tr>
  </tbody>
</template>

<script>
import { CurrencyBR, DecimalNumber } from '@/components/primitives/helpers/filters'
import { IconLockGliph, IconStar } from '@/components/primitives/icons'

export default {
  name: 'ListItems',
  components: {
    IconLockGliph,
    IconStar
  },
  props: {
    list: {
      type: Array,
      default: null
    },
    columnContraction: {
      costLab: false,
      costUnit: false,
      costTotal: false,
      maxLab: false,
      maxUnit: false,
      maxTotal: false,
      estimatedLab: false,
      estimatedUnit: false,
      estimatedTotal: false,
      proposalUnit: false,
      proposalTotal: false,
      minimumUnit: false,
      minimumTotal: false,
      rankingDistributor: false,
      rankingLab: false,
      rankingUnit: false,
      rankingTotal: false
    }
  },
  filters: {
    CurrencyBR,
    DecimalNumber
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-map/components/list-items/ListItems.vue